import { styled } from '@material-ui/core';
import type React from 'react';

import { useTheme } from '../../../theme';

const ToggleButton = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'width': 40,
	'height': 40,
	'padding': 8,
	'border': 'none',
	'borderRadius': 'var(--radius-lg)',
	'backgroundColor': 'transparent',
	'color': 'var(--color-text-primary)',
	'cursor': 'pointer',
	'transition': 'background-color var(--transition-fast), transform var(--transition-fast)',
	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
	},
	'&:active': {
		transform: 'scale(0.95)',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-border-focus)',
		outlineOffset: 2,
	},
});

const SunIcon = () => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<circle
			cx='12'
			cy='12'
			r='5'
		/>
		<line
			x1='12'
			y1='1'
			x2='12'
			y2='3'
		/>
		<line
			x1='12'
			y1='21'
			x2='12'
			y2='23'
		/>
		<line
			x1='4.22'
			y1='4.22'
			x2='5.64'
			y2='5.64'
		/>
		<line
			x1='18.36'
			y1='18.36'
			x2='19.78'
			y2='19.78'
		/>
		<line
			x1='1'
			y1='12'
			x2='3'
			y2='12'
		/>
		<line
			x1='21'
			y1='12'
			x2='23'
			y2='12'
		/>
		<line
			x1='4.22'
			y1='19.78'
			x2='5.64'
			y2='18.36'
		/>
		<line
			x1='18.36'
			y1='5.64'
			x2='19.78'
			y2='4.22'
		/>
	</svg>
);

const MoonIcon = () => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<path d='M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z' />
	</svg>
);

interface ThemeToggleProps {
	className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
	const { resolvedTheme, toggleTheme } = useTheme();
	const isDark = resolvedTheme === 'dark';

	return (
		<ToggleButton
			onClick={toggleTheme}
			className={className}
			aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
			title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
		>
			{isDark ? <SunIcon /> : <MoonIcon />}
		</ToggleButton>
	);
};

export default ThemeToggle;
